import React, {FC} from 'react';
import './style.scss';
import mixerCount from "../../../assets/img/mixer_count.svg";
import Search from '../Search';
import { useHistory } from 'react-router-dom';

interface ISearchPanel {
    value: string,
    setValue: any,
    tobaccoCount: number
}

const SearchPanel: FC<ISearchPanel> = ({
                                           value,
                                           setValue,
                                           tobaccoCount
                                       }) => {
    const history = useHistory();
    return (
        <div className="search-panel__header">
            <div className="search-panel__search">
                <Search
                    value={value}
                    onChange={setValue}
                />
                <div className="search-panel__mixer"
                     onClick={() => history.push("/mixer/mixer-now")}
                >
                    <img
                        className="search-panel__mixer-img"
                        src={mixerCount}
                        alt="mixer"
                    />
                        {
                            tobaccoCount
                                ? (
                                    <div className="search-panel__count">
                                        {tobaccoCount}
                                    </div>
                                )
                                : null
                        }

                </div>
            </div>
        </div>
    )
};

export default SearchPanel;
